import React from 'react'
import { Pie } from '@ant-design/plots'

import { colors, segmentationPalette } from '../../colorPalete'

const Donought = ({ Data, legend, synopsis, responseRate }) => {
  var data = [
    {
      type: 'Male',
      value: 9,
    },
    {
      type: 'Female',
      value: 25,
    },
  ]
  var config = {
    appendPadding: 10,
    data: Data?.length > 0 ? Data : data,
    angleField: 'value',
    color: responseRate ? segmentationPalette : colors,
    legend: legend
      ? false
      : {
          layout: 'horizontal',
          position: 'bottom',
        },
    // legend: {
    //   layout: "horizontal",
    //   position: "bottom",
    // },
    colorField: 'type',
    // eslint-disable-next-line
    color: ['#ffd700', 'purple', 'blue', 'silver', 'green', '#7FB375', 'yellow', 'orange', 'red'],
    radius: 0.85,
    innerRadius: synopsis ? 0.55 : 0.5,
    label: synopsis
      ? false
      : {
          type: 'outer',
          offset: '60%',
          content: '{percentage}',
          style: {
            textAlign: 'center',
            fontSize: 15,
          },
        },
    interactions: [{ type: 'element-selected' }, { type: 'element-active' }],
    statistic: {
      title: false,
      content: {
        style: {
          whiteSpace: 'pre-wrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        },
        content: '',
      },
    },
  }
  return <Pie {...config} height={synopsis ? 250 : 'auto'} />
}

export default Donought
